var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.event.scheduleVisible)?_c('div',{staticClass:"muted--text",class:`text-${_vm.alignText}`,staticStyle:{"font-size":"16px"}},[_vm._v("\n  "+_vm._s(_vm.$t("events:EventCard.registrationDeadline.text"))+"\n  "),(
      !_vm.event.registrationEndDatesPerCompetition || _vm.deadlineDates.length == 1
    )?[_vm._v("\n    "+_vm._s(_vm.deadline)+"\n  ")]:(
      _vm.event.registrationEndDatesPerCompetition && _vm.showApplicableCheckSchedule
    )?[_vm._v("\n    "+_vm._s(_vm.$t(
        "events:EventCard.registrationDeadline.checkSchedule.text",
        "check schedule"
      ))+"\n  ")]:[(_vm.$vuetify.breakpoint.mdAndUp)?[_vm._v("\n      "+_vm._s(_vm.groupedDeadlines.join("; "))+"\n    ")]:_vm._l((_vm.groupedDeadlines),function(deadlines){return _c('div',{key:deadlines,staticClass:"my-1"},[_vm._v("\n        "+_vm._s(deadlines)+"\n      ")])})]],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }